// angular
import { Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
// interfaces & types
import {
  IAllProductsResponse,
  IProduct,
} from '@app/+products/shared/interfaces/product.interface';
import { FavoriteStatuses } from './interfaces/favorites.type';

@Injectable()
export class FavoritesService {
  // states
  public favoriteProductsList = signal<IProduct[]>([]);
  public allFAvoritesProductsCount = signal<number | null>(null);
  public isFavoriteProductsLoading = signal<boolean>(false);

  // dependencies
  private readonly _httpClient = inject(HttpClient);

  constructor() {}

  public addProductToFavorite(id: string) {
    return this._httpClient
      .post<FavoriteStatuses>(`main/products/favorites/${id}`, {})
      .subscribe({
        next: res => {},
        // error: () => this._spinner.hide(),
        // complete: () => ,
      });
  }

  public getFavoriteProducts(params: Params) {
    // empty productsList on every new api call
    this.favoriteProductsList.set([]);
    // set is loading to true
    this.isFavoriteProductsLoading.set(true);

    // api call
    return this._httpClient
      .get<IAllProductsResponse>(`main/products/favorites`, {
        params: {
          ...params,
        },
      })
      .subscribe({
        next: res => {
          const favoriteProducts = res.data;
          this.allFAvoritesProductsCount.set(res.count);
          this.favoriteProductsList.set(favoriteProducts);
        },
        error: () => this.isFavoriteProductsLoading.set(false),
        complete: () => this.isFavoriteProductsLoading.set(false),
      });
  }

  public removeAllProducts() {
    this._httpClient
      .delete<FavoriteStatuses>(`main/products/favorites`)
      .subscribe({
        next: res => {
          if (res.status) {
            this.favoriteProductsList.set([]);
            this.allFAvoritesProductsCount.set(0);
          }
        },
        error: err => {},
        complete: () => {},
      });
  }

  public removeOneFavoriteItem(id: string) {
    this._httpClient
      .delete<FavoriteStatuses>(`main/products/favorites/${id}`)
      .subscribe({
        next: res => {
          if (res.status === false) {
            const productsList = this.favoriteProductsList()?.filter(
              product => product._id !== id
            );
            this.favoriteProductsList.set(productsList || []);
            // set count
            const productsCount = this.allFAvoritesProductsCount() || 1;
            this.allFAvoritesProductsCount.set(productsCount - 1);
          }
        },
        error: err => {},
        complete: () => {},
      });
  }
}
